export default __webpack_public_path__ + "static/media/checkx.6875db59.jpg";